<template>
  <div>
    <slot></slot>
    <!-- Add skills modal -->
    <div class="modal-overlay" v-if="option.add_assignment_modal">
      <div class="modal">
        <div class="modal-header">
          <span class="title">{{ modal_title | validate }}</span>
          <button class="modal-btn-close" @click="closeAssignement()">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <form data-vv-scope="form-1">
            <!-- Tab item -->
            <div class="tab" v-animate-css="'fadeIn'" v-show="modal_tabs[0].active">
              <div class="tab-one-widget">
                <div class="input-group">
                  <div class="input">
                    <input type="text" v-model="fields.assignment_name" class="form-control" placeholder="Assignment name"
                      name="assignment_name" v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.assignment_name')">Assignment name is
                      required</span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input-option">
                    <label for="soon" class="input-option-label">As soon as possible</label>
                    <input type="checkbox" id="soon" v-model="fields.soon_as_possible"
                      :disabled="fields.start_date === ''" />
                  </div>
                  <div class="input" style="z-index: 999">
                    <datepicker :monday-first="true" placeholder="Start date" :disabled-dates="{ to: new Date() }"
                      v-model="fields.start_date" input-class="form-control" wrapper-class="date_picker"
                      name="assignment_start_date" v-validate="'required'"></datepicker>
                    <span class="error_alert" v-if="errors.has('form-1.assignment_start_date')">Start date is
                      required</span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input-option">
                    <label for="role" class="input-option-label">Negotiable</label>
                    <input type="checkbox" id="role" v-model="fields.negotiable" :disabled="fields.rate === ''" />
                  </div>
                  <div class="input">
                    <input type="text" v-model="fields.rate" class="form-control" placeholder="Rate"
                      name="assignment_rate" v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.assignment_rate')">Rate is required</span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input">
                    <map-helper v-model="fields.address"></map-helper>
                    <span class="error_alert" v-if="errors.has('form-1.address')">Location is required</span>
                  </div>
                </div>
                <div class="input-group">
                  <div class="input">
                    <input type="text" v-model="fields.duration" class="form-control" placeholder="Ex: 1 week/month"
                      name="assignment_duration" v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.assignment_duration')">Duration is required</span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input">
                    <input type="text" v-model="fields.role" class="form-control" placeholder="Role"
                      name="assignment_role" v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.assignment_role')">Role is required</span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input">
                    <select v-model="fields.workload">
                      <option :value="0">Select Workload</option>
                      <option value="Part time">Part time</option>
                      <option value="Full time">Full time</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- End tab item -->
          </form>
          <!-- Tab item -->
          <div class="tab" v-animate-css="'fadeIn'" v-show="modal_tabs[1].active">
            <div class="tab-two-widget">
              <label class="tab-label">Assignment description</label>
              <div class="input-flex">
                <textarea class="role-description" v-model="fields.assignment_description"
                  placeholder="Describe the assignment …" name id></textarea>
              </div>
              <label class="tab-label">Roles description</label>
              <div class="input-flex">
                <textarea class="role-description" v-model="fields.role_description" placeholder="Describe the Role…" name
                  id></textarea>
              </div>
              <label class="tab-label">Related skills</label>
              <skills-input v-model="fields.skills" :data="fields.skills_data" />
            </div>
          </div>
          <!-- End tab item -->
          <!-- Tab item -->
          <div class="tab" v-animate-css="'fadeIn'" v-show="modal_tabs[2].active">
            <div class="uploading-widget">
              <label class="title">Supporting image</label>
              <div class="image-upload-widget">
                <upload :crop="false" :value="{
                  url: $fullUrl('images/profiles/'),
                  file_name: fields.cover_photo,
                }" @onFileSelected="setAssignmentLogo" />
              </div>
            </div>
          </div>
          <!-- End tab item -->
          <!-- Tab item -->
          <div class="tab" v-animate-css="'fadeIn'" v-show="modal_tabs[3].active">
            <div class="preview-assagnment-widget">
              <div class="assignments-item-body">
                <h4>{{ fields.assignment_name | validate }}</h4>
                <img v-if="image_url" :src="image_url" alt />
                <img v-else-if="fields.cover_photo" :src="$fullUrl('images/profiles/' + fields.cover_photo)" alt />

                <p>{{ fields.role_description | validate }}</p>
                <label>Skills</label>
                <div class="skills-widget">
                  <div class="skill-item" v-for="(name, index) in skills_list" :key="index + 'skills'">
                    {{ name | validate }}
                  </div>
                </div>
                <div class="assignments-info">
                  <div class="col-one">
                    <label>Role</label>
                    <p>{{ fields.role | validate }}</p>
                    <!-- <label>Location</label>
                    <p>{{fields.country | validate }}, {{fields.city | validate }}</p>-->
                    <label>Start Date</label>
                    <p>
                      {{ fields.start_date | formatDate | validate }}
                      <span v-if="fields.soon_as_possible">/ As soon as possible</span>
                    </p>
                    <label>Duration</label>
                    <p>{{ fields.duration | validate }}</p>
                  </div>
                  <div class="col-two">
                    <label>Work Load</label>
                    <p>{{ fields.workload | validate }}</p>
                    <label>Rate</label>
                    <p>
                      {{ fields.rate | validate }}
                      <span v-if="fields.negotiable">/ Negociable</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End tab item -->
          <!-- Tab item -->
          <div class="tab" v-animate-css="'fadeIn'" v-show="modal_tabs[4].active">
            <div class="success-widget">
              <div class="success-avatar">
                <span class="success-icon">
                  <span class="mdi mdi-check"></span>
                </span>
                <h2>Assignment successfully created</h2>
                <button @click="finishAddAssignment()" class="btn-finish">
                  Proceed
                </button>
              </div>
            </div>
          </div>
          <!-- End tab item -->
        </div>
        <div class="modal-footer">
          <div class="slider-dots" v-if="modal_current_tab < 3">
            <span v-for="(item, index) in modal_tabs" :key="index + 'dot'" class="dot"
              v-bind:class="{ active: item.active }"></span>
          </div>
          <div class="slider-options" v-if="modal_current_tab < 3">
            <button class="btn-prev" :class="{ active: modal_current_tab > 0 }" @click="modelPrev()">
              Previous
            </button>
            <button class="btn-next" @click="modelNext()">Next</button>
          </div>
          <div class="confirm-widget" v-if="modal_current_tab == 3">
            <button class="btn-cancel" @click="modelPrev()">Back</button>
            <consultfied-button @click="submitAssignment()" class="btn-comfirm" :loading="loading">Confirm
              Assignment</consultfied-button>
          </div>
        </div>
      </div>
    </div>
    <!-- End of add skills modal -->
  </div>
</template>
<script>
import upload from "@/components/Partials/Uploader.vue";
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import skillsInput from "@/components/Partials/skillsInput.vue";
import moment from "moment";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
export default {
  name: "add-assignment",
  components: {
    upload,
    Datepicker,
    skillsInput,
    consultfiedButton,
  },
  computed: {
    ...mapGetters(["getCountries", "getCities"]),
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {
          assignment_name: "",
          address: "",
          start_date: "",
          soon_as_possible: false,
          duration: "",
          role: "",
          rate: "",
          negotiable: false,
          workload: 0,
          role_description: "",
          skills_data: [],
          skills: {
            tools: [],
            languages: [],
            domains: [],
            competences: [],
            roles: [],
            removedtools: [],
            removedlanguages: [],
            removeddomains: [],
            removedcompetences: [],
            removedroles: [],
          },
          cover_photo: "",
          assignment_logo: null,
        };
      },
    },
  },
  watch: {
    fields: {
      handler: function (val) {
        let data = [];
        Object.keys(val.skills).forEach(function (key) {
          if (
            key === "tools" ||
            key === "languages" ||
            key === "domains" ||
            key === "competences" ||
            key === "roles"
          ) {
            val.skills[key].forEach((item) => {
              data.push(item.name);
            });
          }
        });
        this.skills_list = data;
      },
      deep: true,
    },
    visible: function (val) {
      this.option.add_assignment_modal = val;
    },
    value: function (item) {
      let vm = this;
      if (item.id) {
        vm.assignment_data = item;
        vm.fields.id = item.id;
        vm.fields.assignment_name = item.title;
        vm.fields.address = item.address;
        vm.fields.start_date = item.due_date_from;
        vm.fields.soon_as_possible = item.is_urgent;
        vm.fields.duration = item.duration;
        vm.fields.role = item.role;
        vm.fields.rate = item.rate;
        vm.fields.negotiable = item.is_negotiable;
        vm.fields.workload = item.work_load;
        vm.fields.assignment_description = item.assignment_description;
        vm.fields.role_description = item.description;
        vm.fields.assignment_logo = null;
        vm.fields.cover_photo = item.cover_photo;
        vm.fields.location_id = item.location.id;
        vm.fields.skills_data = item.skills_data;
      } else {
        vm.modal_current_tab = 0;
        vm.fields.assignment_name = null;
        vm.fields.address = "";
        vm.fields.start_date = null;
        vm.fields.soon_as_possible = null;
        vm.fields.duration = null;
        vm.fields.role = null;
        vm.fields.rate = null;
        vm.fields.negotiable = null;
        vm.fields.workload = 0;
        vm.fields.role_description = null;
        vm.fields.cover_photo = "";
        vm.fields.assignment_logo = null;
        vm.fields.skills_data = [];
        vm.fields.skills = {
          tools: [],
          languages: [],
          domains: [],
          competences: [],
          roles: [],
          removedtools: [],
          removedlanguages: [],
          removeddomains: [],
          removedcompetences: [],
          removedroles: [],
        };
      }
    },
  },
  data: () => {
    return {
      loading: false,
      assignment_data: {},
      option: { add_assignment_modal: false },
      modal_current_tab: 0,
      active_skill_tab: "tools",
      skill_name: "",
      //[{type:'tool',name:'php'}]
      added_skills: [],
      modal_title: "Assignment description",
      modal_tabs: [
        {
          active: true,
          enabled: true,
          title: "Assignment description",
        },
        {
          active: false,
          enabled: false,
          title: "Assignment skills",
        },
        {
          active: false,
          enabled: false,
          title: "Supporting image",
        },
        {
          active: false,
          enabled: false,
          title: "Assignment creation",
        },
        {
          active: false,
          enabled: false,
          title: "Assignment created",
        },
      ],
      fields: {
        assignment_name: "",
        address: "",
        start_date: "",
        soon_as_possible: false,
        duration: "",
        role: "",
        rate: "",
        negotiable: false,
        workload: 0,
        role_description: "",
        skills: {
          tools: [],
          languages: [],
          domains: [],
          competences: [],
          roles: [],
          removedtools: [],
          removedlanguages: [],
          removeddomains: [],
          removedcompetences: [],
          removedroles: [],
        },
        cover_photo: "",
        assignment_logo: null,
      },
      skills_list: [],
      image_url: null,
    };
  },
  mounted() {
    this.$store.dispatch("GET_COUNTRIES");
  },
  methods: {
    moment,
    closeAssignement() {
      this.option.add_assignment_modal = false;
      this.$emit("onClose");
    },
    finishAddAssignment() {
      let vm = this;
      vm.option.add_assignment_modal = false;
      this.$emit("onFinish");
    },
    submitAssignment() {
      let vm = this;
      vm.loading = true;
      // start  Submit
      let formData = new FormData();
      formData.append("assignment_name", vm.fields.assignment_name);
      formData.append("address", vm.fields.address);
      formData.append(
        "start_date",
        vm.moment(vm.fields.start_date).format("YYYY-MM-DD")
      );
      formData.append("duration", vm.fields.duration);
      formData.append("role", vm.fields.role);
      formData.append("rate", vm.fields.rate);
      if (vm.fields.soon_as_possible) {
        formData.append("soon_as_possible", 1);
      } else {
        formData.append("soon_as_possible", 0);
      }

      if (vm.fields.negotiable) {
        formData.append("negotiable", 1);
      } else {
        formData.append("negotiable", 0);
      }

      formData.append("workload", vm.fields.workload);

      formData.append(
        "assignment_description",
        vm.fields.assignment_description
      );
      formData.append("role_description", vm.fields.role_description);
      if (vm.fields.assignment_logo) {
        formData.append(
          "assignment_logo",
          vm.fields.assignment_logo,
          vm.fields.assignment_logo.name
        );
      }
      formData.append("tools", JSON.stringify(vm.fields.skills.tools));
      formData.append("domains", JSON.stringify(vm.fields.skills.domains));
      formData.append(
        "competences",
        JSON.stringify(vm.fields.skills.competences)
      );
      formData.append("roles", JSON.stringify(vm.fields.skills.roles));
      formData.append("languages", JSON.stringify(vm.fields.skills.langs));

      formData.append(
        "removedtools",
        JSON.stringify(vm.fields.skills.removedtools)
      );
      formData.append(
        "removedlanguages",
        JSON.stringify(vm.fields.skills.removedlanguages)
      );
      formData.append(
        "removeddomains",
        JSON.stringify(vm.fields.skills.removeddomains)
      );
      formData.append(
        "removedcompetences",
        JSON.stringify(vm.fields.skills.removedcompetences)
      );
      formData.append(
        "removedroles",
        JSON.stringify(vm.fields.skills.removedroles)
      );

      // when no data to update
      if (!this.value.id) {
        vm.$store
          .dispatch("ADD_NEW_ASSIGNMENT", formData)
          .then((response) => {
            vm.loading = false;
            vm.modelNext();
            console.log(response);
          })
          .catch((error) => {
            vm.loading = false;
            console.log(error);
          });
      } else {
        // when there is data to update
        formData.append("id", vm.fields.id);
        vm.$store
          .dispatch("UPDATE_ASSIGNMENT", formData)
          .then((response) => {
            vm.loading = false;
            vm.modelNext();
          })
          .catch((error) => {
            vm.loading = false;
            console.log(error);
          });
      }
    },
    setAssignmentLogo(file) {
      let vm = this;
      if (file) {
        vm.fields.cover_photo = "";
        vm.fields.assignment_logo = file;
        vm.image_url = URL.createObjectURL(file);
      }
    },
    modelPrev() {
      let vm = this;
      if (vm.modal_current_tab > 0) {
        vm.modal_tabs[vm.modal_current_tab].active = false;
        vm.modal_tabs[vm.modal_current_tab].enabled = false;
        vm.modal_current_tab -= 1;
        vm.modal_tabs[vm.modal_current_tab].active = true;
        vm.modal_tabs[vm.modal_current_tab].enabled = true;
        vm.modal_title = vm.modal_tabs[vm.modal_current_tab].title;
      }
    },
    modelNext() {
      let vm = this;
      if (vm.modal_current_tab === 0) {
        vm.$validator.validateAll("form-1").then((isError) => {
          if (isError === true) {
            vm.modal_tabs[vm.modal_current_tab].active = false;
            vm.modal_tabs[vm.modal_current_tab].enabled = false;
            vm.modal_current_tab += 1;
            vm.modal_tabs[vm.modal_current_tab].active = true;
            vm.modal_tabs[vm.modal_current_tab].enabled = true;
            vm.modal_title = vm.modal_tabs[vm.modal_current_tab].title;
          }
        });
      } else {
        if (vm.modal_tabs.length - 1 > vm.modal_current_tab) {
          vm.modal_tabs[vm.modal_current_tab].active = false;
          vm.modal_tabs[vm.modal_current_tab].enabled = false;
          vm.modal_current_tab += 1;
          vm.modal_tabs[vm.modal_current_tab].active = true;
          vm.modal_tabs[vm.modal_current_tab].enabled = true;
          vm.modal_title = vm.modal_tabs[vm.modal_current_tab].title;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba($color: #000000, $alpha: 0.89);
  z-index: 9999999;
  display: flex;
  justify-content: center;
  padding-top: 100px;
  padding-bottom: 50px;
  overflow-y: auto;

  @media (min-width: 300px) and (max-width: 630px) {
    padding-top: 55px;
  }

  .modal {
    width: 600px;
    background: #f5f5f5;
    border-radius: 5px;
    display: inline-table;

    @media (min-width: 300px) and (max-width: 630px) {
      width: 100%;
    }

    .modal-header {
      display: flex;
      height: 80px;
      background: #0884af 0% 0% no-repeat padding-box;
      border-radius: 5px 5px 0px 0px;
      align-items: center;
      justify-content: space-between;
      padding-left: 40px;
      padding-right: 40px;

      .title {
        color: #fff;
        font-size: 20px;
      }

      .modal-btn-close {
        background: transparent;
        font-size: 30px;
        color: #fff;
        border: none;
        outline: none;
        cursor: pointer;
      }
    }

    .modal-body {
      .tab {
        padding-left: 40px;
        padding-right: 40px;
        padding-top: 25px;

        .tab-one-widget {
          display: grid;
          grid-column-gap: 20px;
          grid-template-columns: 48% 48%;

          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 100%;
          }

          .input-group {
            width: 100%;
            display: flex;
            margin-bottom: 40px;
            flex-direction: column;
            justify-content: flex-end;

            @media (min-width: 300px) and (max-width: 630px) {
              margin-bottom: 10px;
            }

            .input-option {
              display: flex;
              justify-content: flex-end;
              padding-right: 0px;
              align-items: center;
              margin-bottom: 5px;

              .input-option-label {
                color: #031019;
                font-size: 12px;

                margin-right: 7px;
              }
            }

            .input {
              display: flex;
              width: 100%;

              flex-direction: column;
              z-index: 1;

              .form-control {
                border-radius: 5px;
                border: 1px solid #ddd;
                padding: 10px 10px;
                width: 100%;
                outline: none;
                font-size: 14px;

                height: 50px;
                background: #fff;
              }

              .date_picker {
                width: 100%;
                outline: none;
                font-size: 14px;

                height: 50px;
                background: #fff;
                border: 1px solid #ddd;
                border-radius: 5px;
                display: flex;
                align-items: center;
                padding-left: 10px;
              }

              select {
                border-radius: 5px;
                border: 1px solid #ddd;
                padding: 10px 10px;
                width: 100%;
                outline: none;
                height: 50px;
                font-size: 14px;
                background: #fff;
                color: #707070;
              }

              input::placeholder {
                color: #707070;
              }
            }
          }
        }

        .tab-two-widget {
          width: 100%;

          .tab-label {
            margin-left: 20px;
            margin-bottom: 10px;
            display: block;
          }

          .role-description {
            background: #ffffff 0% 0% no-repeat padding-box;
            border-radius: 5px;
            width: 100%;
            height: 100px;
            border: 1px solid #ddd;
            font-size: 14px;

            padding: 10px;
            outline: none;
            margin-bottom: 20px;
          }

          .role-description::placeholder {
            color: #b2b2b2;
          }

          .skills-widget {
            background: #fff;
            border-radius: 5px;
            border: 1px solid #ddd;

            .skill-tabs {
              background: #cccccc;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-radius: 5px 5px 0px 0px;

              .skill-tab-item {
                color: #fff;
                padding: 20px 20px;

                cursor: pointer;
              }

              .skill-tab-item.active {
                color: #1ba5a4;
                background: #fff;
                border-radius: 5px 0px 0px 0px;
              }
            }

            .skill-tabs-body {
              padding: 20px;

              label {
                margin-bottom: 6px;
                margin-top: 30px;
                display: block;
                text-transform: capitalize;
              }

              .input-group {
                display: flex;

                input {
                  background: #f4f4f4 0% 0% no-repeat padding-box;
                  border-radius: 5px;
                  width: 100%;
                  border: none;
                  margin-right: 20px;
                  padding: 10px 10px;
                  height: 35px;
                  font-size: 14px;
                  outline: none;
                }

                .add-btn {
                  border: 1px solid #ccc;
                  border-radius: 5px;
                  width: 150px;
                  font-size: 14px;
                  outline: none;
                  cursor: pointer;
                }
              }

              .added-skills-list {
                display: flex;
                flex-wrap: wrap;

                .skill-item {
                  padding: 10px 30px;
                  background: #1ba5a4 0% 0% no-repeat padding-box;
                  border-radius: 20px;
                  color: #fff;
                  margin-right: 10px;
                  font-size: 14px;

                  font-weight: 800;
                  margin-bottom: 10px;
                  text-transform: capitalize;
                }
              }
            }
          }
        }

        .uploading-widget {
          width: 100%;
          padding-right: 40px;

          .title {}
        }

        .preview-assagnment-widget {
          .assignments-item-body {
            padding: 10px;

            h4 {
              font-size: 20px;
              font-weight: 500;
              margin-bottom: 10px;
            }

            img {
              width: 100%;
            }

            p {
              font-size: 14px;
            }

            label {
              color: #808080;
              font-size: 15px;
              display: block;
              margin-bottom: 8px;
            }

            .skills-widget {
              display: flex;
              flex-wrap: wrap;

              .skill-item {
                background: #707070 0% 0% no-repeat padding-box;
                border-radius: 25px;
                color: #ffffff;
                font-size: 13px;

                padding: 5px 22px;
                margin-right: 10px;
                margin-bottom: 10px;
              }
            }

            .assignments-info {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;

              .col-one,
              .col-two {
                width: 50%;

                label {
                  color: #808080;
                  margin-bottom: 3px;
                  margin-top: 20px;
                }

                p {
                  color: #000;
                  margin: 0px;
                }
              }
            }
          }
        }

        .success-widget {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          margin-top: 30px;
          margin-bottom: 30px;

          .success-avatar {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .success-icon {
              height: 150px;
              width: 150px;
              border: 1px solid #04a5a5;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 121px;
              color: #04a5a5;
              margin-bottom: 40px;
            }

            h2 {
              margin-bottom: 40px;
            }

            .btn-finish {
              background: #1890a9 0% 0% no-repeat padding-box;
              border-radius: 5px;
              width: 241px;
              padding: 14px;
              color: #fff;
              font-size: 14px;
              border: none;
            }
          }
        }
      }
    }

    .modal-footer {
      display: flex;
      flex-direction: column;
      height: 100px;
      justify-content: center;
      align-items: center;

      .slider-dots {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        .dot {
          height: 9px;
          width: 9px;
          display: block;
          background: #d9d9d9;
          border-radius: 50%;
          margin-right: 6px;
        }

        .dot.active {
          height: 12px;
          width: 12px;
          display: block;
          background: #04a4a5;
          border-radius: 50%;
        }
      }

      .slider-options {
        display: grid;
        grid-template-columns: 50% 50%;
        grid-column-gap: 20px;

        .btn-prev {
          background: transparent;
          border: none;
          color: #b2b2b2;
          font-size: 16px;
          cursor: pointer;
          outline: none;
        }

        .btn-prev.active {
          color: #0085b0;
        }

        .btn-next {
          background: transparent;
          border: none;
          color: #0085b0;
          font-size: 16px;
          cursor: pointer;
          outline: none;
        }
      }

      .confirm-widget {
        display: flex;

        .btn-comfirm {
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
          padding: 10px 10px;
          border: none;
          font-size: 14px;

          cursor: pointer;
        }

        .btn-cancel {
          border: none;
          font-size: 14px;

          color: #0590ab;
          background: transparent;
          cursor: pointer;
          margin-right: 10px;
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>
